// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type MoneyBackGuarantee48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const MoneyBackGuarantee48: FC<MoneyBackGuarantee48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M7 16h34v-5H7v5Zm-3-5c0-.8.3-1.5.9-2.1C5.5 8.3 6.2 8 7 8h34c.8 0 1.5.3 2.1.9.6.6.9 1.3.9 2.1v11.95H7V37h11.65v3H7c-.8 0-1.5-.3-2.1-.9-.6-.6-.9-1.3-.9-2.1V11Zm25.9 33-8.5-8.5 2.15-2.15 6.35 6.35 12-12 2.1 2.2L29.9 44ZM7 11v26-7.9 6.5V11Z" />
        </svg>
    );
};

export default MoneyBackGuarantee48;
